<template>
  <div>
    <portal to="authTitle">
      <h2
        class="mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl"
        id="formtitle"
      >
        Reset your password
      </h2>
    </portal>

    <div
      id="formio-set-password"
      v-if="validToken"
      role="form"
      aria-labelledby="formtitle"
    ></div>
    <div v-else>
      <label class="block text-center">
        <span class="font-semibold text-gray-600">
          Your password reset link has expired. Please generate a new password
          reset link
          <router-link
            class="text-teal-900 font-semibold"
            :to="'/forgot-password'"
          >
            here.
          </router-link>
        </span>
      </label>
    </div>
    <div class="mt-6 text-sm text-center text-gray-600">
      <p>
        <span class="block">
          I changed my mind,
          <span
            class="text-teal-900 font-semibold cursor-pointer"
            @click="cancelPasswordChange(true)"
          >
            I don't want to change my password
          </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { Formio } from "formiojs";
import tailwind from "@apiabroad/formio-tailwind-template";
import { CONSTANT_KEYS } from "../../constants";

export default {
  data() {
    return {
      validToken: true,
      password: ""
    };
  },
  beforeMount() {
    this.$emit("logout");
    let token = "";
    let tokenParam = this.$route.query[CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY];
    if (tokenParam) {
      // Token set by querystring
      localStorage.setItem(CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY, tokenParam);
      token = tokenParam;
    } else if (localStorage.getItem(CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY)) {
      // Token set by localstorage
      token = localStorage.getItem(CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY);
    } else {
      // No token
      this.$router.push("/sign-in");
    }
    if (token) {
      Formio.setBaseUrl(process.env.VUE_APP_FORMIO_BASE_URL);
      Formio.setToken(token)
        .then(() => {
          console.log("Token has been set (By a Vue component)");
          localStorage.setItem(CONSTANT_KEYS.PASSWORD_STORAGE_KEY, "yes");
        })
        .catch(() => {
          this.validToken = false;
          localStorage.removeItem(CONSTANT_KEYS.PASSWORD_STORAGE_KEY);
          localStorage.removeItem(CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY);
        });
    }
  },
  mounted() {
    Formio.use(tailwind);
    Formio.createForm(
      document.getElementById("formio-set-password"),
      process.env.VUE_APP_FORMIO_URL + "/advisorpasswordresetform",
      {
        hooks: {
          beforeSubmit: (submission, next) => {
            //Set hide inputs
            this.password = submission.data.password;
            next();
          }
        }
      }
    ).then(form => {
      // eslint-disable-next-line no-unused-vars
      form.on("submit", submission => {
        Formio.currentUser().then(user => {
          Formio.setUser(user);
          user.data.password = this.password;
          const userFormio = new Formio(
            process.env.VUE_APP_FORMIO_URL + "/advisor/submission/" + user._id
          );
          // eslint-disable-next-line no-unused-vars
          userFormio.saveSubmission(user).then(usersubmission => {
            this.password = "";
            this.$emit("setPassword", true);
            this.$emit("logout");
            this.$emit("changeComponent", "reset-confirmation");
            this.cancelPasswordChange();
          });
        });
      });
    });
  },
  methods: {
    cancelPasswordChange(redirect = false) {
      localStorage.removeItem(CONSTANT_KEYS.PASSWORD_STORAGE_KEY);
      localStorage.removeItem(CONSTANT_KEYS.RESET_TOKEN_STORAGE_KEY);
      this.$emit("logout");
      if (redirect) window.location.replace("/sign-in");
    }
  }
};
</script>
